import { RefObject } from "react";
import { useBrowserApiCodeDetector } from "./use-browser-api-code-detector";
import { useZxingCodeDetector } from "./use-zxing-code-detector";
import { CodeScannerFormat } from "../code-scanner/code-scanner";

export const useCameraCodeDetector = (inputScannerRef: RefObject<HTMLVideoElement>,
                                      formats: CodeScannerFormat[], onValueScanned: (value: string) => void) => {
    try {
        useBrowserApiCodeDetector(inputScannerRef, formats, onValueScanned);
    } catch (err) {
        useZxingCodeDetector(inputScannerRef, formats, onValueScanned);
    }
};
